import { CrossFlowViewedScreenNames } from "@atlassian/surface-analytics-specs";
import { Editions, ProductKeys } from "@atlassiansox/asc-stargate";

import { useCrossFlowTouchpointContext } from "../context";

import { useOpenCrossFlow } from "./use-open-crossflow";
import { useCrossFlowFrontendTouchpointComponentViewed } from "./use-touchpoint-component-viewed";

export const useCrossFlowFrontendTouchpoint = (
    {
        productKey,
        screenName,
        redirectUrl,
        edition
    }: {
        productKey?: ProductKeys;
        touchpointViewedOnMount?: boolean;
        screenName?: CrossFlowViewedScreenNames;
        redirectUrl?: string;
        edition?: Editions;
    },
    touchpointViewedOnMount = true
) => {
    const { isCrossFlowEnabled } = useCrossFlowTouchpointContext();
    const onCrossFlowComponentViewed =
        useCrossFlowFrontendTouchpointComponentViewed({
            fireOnMount: isCrossFlowEnabled && touchpointViewedOnMount,
            productKey,
            screenName,
            edition
        });

    const openCrossFlow = useOpenCrossFlow({
        productKey,
        screenName,
        redirectUrl,
        edition
    });

    if (!isCrossFlowEnabled) {
        return {
            isEnabled: false,
            onCrossFlowComponentViewed
        };
    }

    return {
        isEnabled: true,
        openCrossFlow,
        onCrossFlowComponentViewed
    };
};
